import { Typography } from '@interstate/components/Typography';

export const OfferCardStock = ({ stockNumber }: { stockNumber?: string }) => {
    const stockNumberValue = stockNumber ? `#${stockNumber}` : '--';

    return <Typography variant="h6">Stock {stockNumberValue}</Typography>;
};
